// DG Global Utilities
(function () {
  /* DG Theme Loaded */

  // Simple intersection observer utility if needed
  window.DG = window.DG || {};

  /* â•â•â• Sidebar â•â•â• */
  window.openSidebar = function () {
    var sidebar = document.getElementById('dg-sidebar');
    var overlay = document.getElementById('dg-sidebar-overlay');
    if (sidebar) sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  window.closeSidebar = function () {
    var sidebar = document.getElementById('dg-sidebar');
    var overlay = document.getElementById('dg-sidebar-overlay');
    if (sidebar) sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  // Close sidebar on Escape 
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSidebar();
      closeCartDrawer();
    }
  });

  // Sidebar: toggle subcategories on click
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.dg-sidebar__link[data-has-children]');
    if (!link) return;
    e.preventDefault();
    var sub = link.nextElementSibling;
    if (sub && sub.classList.contains('dg-sidebar__sub')) {
      sub.classList.toggle('is-open');
    }
  });

  window.DG.utils = {
    decodeHtmlEntities: function (str) {
      if (!str) return str;
      var el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    },
    formatMoney: function (cents, format) {
      // Basic money formatter - enhance as needed
      if (typeof cents === 'string') { cents = cents.replace('.', ''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || "${{amount}}";

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  };

  // =========================================
  // Global Cart State Management
  // =========================================
  window.DG_cartItems = [];
  var _cartRefreshPromise = null;
  var _drawerRenderId = 0;
  var _currentCart = null;
  window.refreshCartState = function () {
    if (_cartRefreshPromise) return _cartRefreshPromise;
    function attempt(retries) {
      var state = window.DGCart;
      return (state ? state.whenIdle() : Promise.resolve()).then(function () {
        var revision = state ? state.version() : 0;
        var read = state ? state.read() : fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' }).then(function (r) {
          if (!r.ok) throw new Error('Lecture du panier impossible.');
          return r.json();
        });
        return read.then(function (cart) {
          if (!cart || !Array.isArray(cart.items)) throw new Error('Réponse du panier incomplète.');
          if (state && (state.version() !== revision || state.isPending())) return attempt(retries);
          return renderCartDrawer(cart, revision).then(function (rendered) {
            if (!rendered) {
              if (retries >= 2) throw new Error('Le panier a changé pendant son affichage.');
              return attempt(retries + 1);
            }
            _currentCart = cart;
            window.DG_cartItems = cart.items;
            updateAllProductCards();
            updateHeaderBadge(cart);
            document.dispatchEvent(new CustomEvent('dg:cart:updated', { detail: { cart: cart, source: 'dg-cart-state' } }));
            return cart;
          });
        });
      });
    }
    _cartRefreshPromise = attempt(0).catch(function (err) {
      if (window.DGCart) window.DGCart.showError('Le panier n’a pas pu être actualisé. Rechargez la page pour vérifier vos articles.');
      console.error('Error fetching cart state:', err);
      return null;
    }).finally(function () { _cartRefreshPromise = null; });
    return _cartRefreshPromise;
  };
  document.addEventListener('dg:cart:settled', function () { window.refreshCartState(); });

  window.updateAllProductCards = function () {
    const forms = document.querySelectorAll('form[data-type="ajax-counter"]');
    forms.forEach(form => syncCardState(form));
  };

  window.syncCardState = function (form) {
    if (!form) return;

    const variantId = parseInt(form.querySelector('input[name="id"]').value);
    const cartItem = window.DG_cartItems.find(item => item.id === variantId);
    const qty = cartItem ? cartItem.quantity : 0;

    // Mettre à jour data-inventory-qty depuis cart.js ; stock utile = max(qty, 0)
    if (cartItem && typeof cartItem.inventory_quantity !== 'undefined') {
      var invQtyFromCart = parseInt(cartItem.inventory_quantity, 10);
      if (!isNaN(invQtyFromCart)) {
        form.dataset.inventoryQty = Math.max(invQtyFromCart, 0);
      }
    }

    const addBtn = form.querySelector('.dg-product-card__add-btn') || form.querySelector('.dg-product-card__add-btn-inline');
    const counter = form.querySelector('.dg-product-card__counter');
    const valEl = form.querySelector('.dg-counter-val');  // now an <input>
    const actionsContainer = form.closest('.dg-product-card__actions');

    // Update internal state
    form.dataset.qty = qty;

    // â”€â”€ .is-selected: CSS border/glow state when item is in cart â”€â”€
    const card = form.closest('.dg-product-card');
    if (card) {
      if (qty > 0) {
        card.classList.add('is-selected');
      } else {
        card.classList.remove('is-selected');
      }
    }

    if (qty > 0) {
      // Show Counter
      if (addBtn) addBtn.style.display = 'none';
      if (counter) counter.style.display = 'flex';
      if (valEl) valEl.value = qty;  // .value for <input>
      if (actionsContainer) actionsContainer.classList.add('active');
    } else {
      // Show Add Button
      if (counter) counter.style.display = 'none';
      if (addBtn) addBtn.style.display = 'flex';
      if (actionsContainer) actionsContainer.classList.remove('active');
    }

    // Backorder warning (runs for both add-btn and counter states)
    if (typeof updateBackorderWarning === 'function') updateBackorderWarning(form);
  };

  // =========================================
  // Wishlist Toggle (uses dgFav API from dg-favorites-sync.js)
  // =========================================
  /**
   * Item key of a heart button. A favorite is VARIANT-level: the same product sold
   * en Caisse and à l'Unité is two different favorites, at two different prices.
   * Falls back to the product handle when the button predates the variant data
   * (guest carts, cached markup) so nothing stops working mid-deploy.
   */
  function dgFavKey(btn) {
    if (btn.dataset.variantId) return 'v:' + btn.dataset.variantId;

    var handle = btn.dataset.productHandle || null;
    if (!handle) {
      var card = btn.closest('.dg-product-card');
      var anchor = card && card.querySelector('.dg-product-card__link, a[href*="/products/"]');
      var href = anchor && (anchor.getAttribute('href') || anchor.href || '');
      handle = href ? href.replace(/.*\/products\//, '').split('?')[0].split('/')[0] : null;
    }
    return handle || null;
  }

  function dgFavMeta(btn) {
    return {
      h: btn.dataset.productHandle || '',
      s: btn.dataset.sku || '',
      t: btn.dataset.title || '',
      u: btn.dataset.isUnit === '' || btn.dataset.isUnit == null
        ? null : Number(btn.dataset.isUnit)
    };
  }

  window.dgToggleWishlist = function (btn) {
    var key = dgFavKey(btn);
    if (!key || typeof window.dgFav === 'undefined') return;

    var isWishlisted = window.dgFav.toggle(key, dgFavMeta(btn));

    /* Sync every heart pointing at the SAME variant (not the same product: the
       other format is a distinct favorite and must keep its own state). */
    var sel = btn.dataset.variantId
      ? '.dg-product-card__wishlist[data-variant-id="' + btn.dataset.variantId + '"]'
      : null;
    if (sel) {
      document.querySelectorAll(sel).forEach(function (b) {
        b.classList.toggle('is-wishlisted', isWishlisted);
      });
    } else {
      btn.classList.toggle('is-wishlisted', isWishlisted);
    }
    if (typeof window.dgRefreshCardHeart === 'function') window.dgRefreshCardHeart(btn.closest('.dg-product-card'));
  };

  /**
   * Repaint one card's heart: filled for the selected format, plus a discreet
   * secondary state when ANOTHER format of the same product is favorited. Without
   * that second state the heart would look empty on a product the customer has
   * already saved, and lie about what the click will do.
   */
  window.dgRefreshCardHeart = function (card) {
    if (!card || typeof window.dgFav === 'undefined') return;
    var btn = card.querySelector('.dg-product-card__wishlist');
    if (!btn) return;
    var key = dgFavKey(btn);
    var mine = key ? window.dgFav.has(key) : false;
    btn.classList.toggle('is-wishlisted', mine);

    var autre = false;
    if (!mine && btn.dataset.productHandle) {
      var keys = window.dgFav.list();
      for (var i = 0; i < keys.length; i++) {
        var info = window.dgFav.keyInfo(keys[i]);
        if (info && info.handle === btn.dataset.productHandle) { autre = true; break; }
      }
    }
    btn.classList.toggle('is-wishlisted--other', autre);
  };

  // Restore wishlist state on page load
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.dgFav === 'undefined') return;
    document.querySelectorAll('.dg-product-card').forEach(function (card) {
      window.dgRefreshCardHeart(card);
    });
    // Cards outside .dg-product-card (PDP, ajax fragments).
    document.querySelectorAll('.dg-product-card__wishlist[data-variant-id]').forEach(function (btn) {
      if (btn.closest('.dg-product-card')) return;
      var key = dgFavKey(btn);
      if (key && window.dgFav.has(key)) btn.classList.add('is-wishlisted');
    });
  });

  // =========================================
  // Product Card Variant Selection
  // =========================================
  window.selectCardVariant = function (btn) {
    if (btn.classList.contains('disabled')) return;

    const card = btn.closest('.dg-product-card');
    const variantId = btn.dataset.variantId;
    const price = btn.dataset.price;
    const comparePrice = btn.dataset.comparePrice;
    const imageUrl = btn.dataset.image;

    // 1. Visual Selection
    card.querySelectorAll('.dg-variant-pill').forEach(pill => pill.classList.remove('selected'));
    btn.classList.add('selected');

    // 2. Update Price
    const priceContainer = card.querySelector('.dg-product-card__price');
    if (priceContainer) {
      if (comparePrice && comparePrice !== '') {
        priceContainer.innerHTML = `<span class="dg-price--regular trash">${comparePrice}</span> <span class="dg-price--sale 11">${price}</span>`;
      } else {
        priceContainer.innerHTML = `<span class="dg-price">${price}</span>`;
      }
    }

    // 3. Update Image (Optional, if variant has image)
    if (imageUrl && imageUrl !== '') {
      const img = card.querySelector('.dg-product-card__img');
      if (img) img.src = imageUrl;
    }

    // 4. Update Quick Add Form ID
    const input = card.querySelector('input[name="id"]');
    if (input) input.value = variantId;

    // 5. Sync Card State with Cart (Check new variant)
    const form = card.querySelector('form[data-type="ajax-counter"]');
    if (form) {
      syncCardState(form);
    }

    // 6. Repoint the heart at the newly selected format — otherwise it keeps
    // showing (and toggling) the previous variant's favorite state.
    dgRepointHeart(card, btn);

    // Update Link (optional, for non-quick-add buttons)
    const link = card.querySelector('.dg-product-card__quick-actions a');
    if (link) {
      const url = new URL(link.href);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    }
  };

  /** Move a card's heart onto `source`'s variant, then repaint it. */
  function dgRepointHeart(card, source) {
    if (!card || !source) return;
    const heart = card.querySelector('.dg-product-card__wishlist');
    if (!heart) return;
    if (source.dataset.variantId) heart.dataset.variantId = source.dataset.variantId;
    if (source.dataset.sku != null) heart.dataset.sku = source.dataset.sku;
    if (source.dataset.isUnit != null) heart.dataset.isUnit = source.dataset.isUnit;
    if (typeof window.dgRefreshCardHeart === 'function') window.dgRefreshCardHeart(card);
  }

  // =========================================
  // Product Card Variant Selection (Select dropdown)
  // =========================================
  window.selectCardVariantFromSelect = function (selectEl) {
    const card = selectEl.closest('.dg-product-card');
    const selected = selectEl.options[selectEl.selectedIndex];

    const variantId = selected.value;
    const price = selected.dataset.price;
    const comparePrice = selected.dataset.comparePrice;
    const imageUrl = selected.dataset.image;

    // 1. Update Price
    const priceContainer = card.querySelector('.dg-product-card__price');
    if (priceContainer) {
      if (comparePrice && comparePrice !== '') {
        priceContainer.innerHTML = `<span class="dg-price--regular">${comparePrice}</span> <span class="dg-price--sale">${price}</span>`;
      } else {
        priceContainer.innerHTML = `<span class="dg-price" data-wpd-product-handle="${priceContainer.getAttribute("data-base-handle")}" data-wpd-variant-compare-at-price="${comparePrice}" data-wpd-variant-price="${priceContainer.getAttribute("data-base-price")}" data-wpd-variant-id="${variantId}">${price}</span>`;
      }
    }

    // 2. Update Image
    if (imageUrl && imageUrl !== '') {
      const img = card.querySelector('.dg-product-card__img');
      if (img) img.src = imageUrl;
    }

    // 3. Update cart form hidden input
    const input = card.querySelector('input[name="id"]');
    if (input) input.value = variantId;

    // 4. Sync counter state
    const form = card.querySelector('form[data-type="ajax-counter"]');
    if (form) syncCardState(form);

    // 4b. Repoint the heart at the selected format (Caisse ⇄ Unité are two
    // distinct favorites, so the heart must follow the dropdown).
    dgRepointHeart(card, selected);

    // 5. Prix par 100g — prix wholesale de l'option sélectionnée
    var wcpCents = selected.dataset.wcpPriceCents;
    if (wcpCents) card.dataset.wcpPriceCents = wcpCents;
    if (typeof window.dgRefreshProductCard === 'function') {
      window.dgRefreshProductCard(card);
      setTimeout(function () { window.dgRefreshProductCard(card); }, 400);
      setTimeout(function () { window.dgRefreshProductCard(card); }, 2000);
    }

    // 6. Update inventory data for backorder warning
    var invQty = selected.dataset.inventoryQty;
    if (form && invQty !== undefined) {
      form.dataset.inventoryQty = Math.max(parseInt(invQty, 10) || 0, 0);
      if (typeof updateBackorderWarning === 'function') updateBackorderWarning(form);
    }

    // 7. Bandeau jaune « En commande » selon le stock de la variante
    var banner = card && card.querySelector('[data-dg-backorder-banner]');
    if (banner) {
      var invMgmt = selected.dataset.inventoryManagement || '';
      var inv = parseInt(selected.dataset.inventoryQty, 10);
      var showBanner = invMgmt === 'shopify' && !isNaN(inv) && inv <= 0;
      banner.hidden = !showBanner;
    }
  };

  // Initial cart sync on page load
  document.addEventListener('DOMContentLoaded', function () {
    refreshCartState();
  });

  // Theme editor: re-sync cart + wishlist after a section re-render
  // (shopify:section:load fires only in the theme editor, never on the live store)
  document.addEventListener('shopify:section:load', function () {
    refreshCartState();
    if (typeof window.dgFav !== 'undefined') {
      document.querySelectorAll('.dg-product-card__wishlist[data-product-handle]').forEach(function (btn) {
        btn.classList.toggle('is-wishlisted', window.dgFav.has(btn.dataset.productHandle));
      });
    }
  });

  // =========================================
  // Cart / panier : schéma de couleur « clair » pour listes natives + Zapiet (color-scheme)
  // =========================================
  function dgSyncFormLightScheme() {
    try {
      var drawer = document.getElementById('dg-cart-drawer');
      var drawerOpen = drawer && drawer.classList.contains('active');
      var p = window.location.pathname || '';
      var cartPage = p === '/cart' || p.indexOf('/cart/') === 0;
      document.documentElement.classList.toggle('dg-form-light', !!(drawerOpen || cartPage));
      if (typeof window.DG_applyZapietSlotMenuTextColors === 'function') {
        window.DG_applyZapietSlotMenuTextColors();
      }
    } catch (e) { /* ignore */ }
  }
  window.dgSyncFormLightScheme = dgSyncFormLightScheme;

  // =========================================
  // Cart Drawer Logic
  // =========================================
  window.openCartDrawer = function () {
    // Don't open drawer when already on the full cart page
    if (window.location.pathname === '/cart') return;
    const drawer = document.getElementById('dg-cart-drawer');
    if (drawer) {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
      // Sync delivery bar with zone-aware threshold
      patchDrawerDeliveryBar();
      if (typeof window.DG_applyZapietSlotMenuTextColors === 'function') {
        [50, 200, 600, 1200].forEach(function (ms) {
          setTimeout(window.DG_applyZapietSlotMenuTextColors, ms);
        });
      }
      dgSyncFormLightScheme();
      window.refreshCartState();
    }
  };

  window.closeCartDrawer = function () {
    const drawer = document.getElementById('dg-cart-drawer');
    if (drawer) {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      dgSyncFormLightScheme();
    }
  };

  window.updateCartDrawer = function () {
    return window.refreshCartState();
  };

  function renderCartDrawer(cart, revision) {
    var renderId = ++_drawerRenderId;
    var target = document.getElementById('dg-cart-drawer-section');
    if (!target) return Promise.resolve(true);
    function displaySignature(value) {
      return JSON.stringify([value.total_price, value.total_discount, value.currency, value.items.map(function (line) {
        return [line.key, line.quantity, line.final_line_price, line.original_line_price];
      })]);
    }
    // Note/attribute saves must not replace a textarea while the customer is typing.
    if (_currentCart && displaySignature(_currentCart) === displaySignature(cart)) {
      patchDrawerDeliveryBar(cart);
      if (window.DGCart) window.DGCart.restoreStatus();
      return Promise.resolve(true);
    }
    target.setAttribute('aria-busy', 'true');
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 20000);
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer-dg', { cache: 'no-store', signal: controller.signal })
      .then(function (res) { if (!res.ok) throw new Error('Rendu du panier impossible.'); return res.json(); })
      .then(data => {
        if (renderId !== _drawerRenderId || (window.DGCart && (window.DGCart.version() !== revision || window.DGCart.isPending()))) return false;
        const sectionId = 'cart-drawer-dg';
        const newContent = data[sectionId];
        const drawerSection = document.getElementById('dg-cart-drawer-section');

        if (drawerSection && newContent) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(newContent, 'text/html');
          const newDrawerSection = doc.getElementById('dg-cart-drawer-section');
          const renderedDrawer = doc.getElementById('dg-cart-drawer');
          if (!renderedDrawer || Number(renderedDrawer.dataset.cartCount) !== cart.item_count || Number(renderedDrawer.dataset.cartTotal) !== cart.total_price) return false;
          var renderedLines = (renderedDrawer.dataset.cartLines || '').split(';').filter(Boolean).sort().join(';');
          var expectedLines = cart.items.map(function (line) { return line.key + '=' + line.quantity; }).sort().join(';');
          if (renderedLines !== expectedLines) return false;
          if (newDrawerSection) {
            const wasOpen = document.getElementById('dg-cart-drawer')?.classList.contains('active');

            // Sauvegarder la position de scroll avant le re-render
            const itemsList = document.getElementById('dg-cart-items-list');
            const savedScroll = itemsList ? itemsList.scrollTop : 0;
            const note = document.getElementById('dg-cart-note');
            const editingNote = note && document.activeElement === note;
            const noteDraft = editingNote ? { value: note.value, start: note.selectionStart, end: note.selectionEnd } : null;

            drawerSection.innerHTML = newDrawerSection.innerHTML;
            if (noteDraft) {
              const replacement = document.getElementById('dg-cart-note');
              if (replacement) {
                replacement.value = noteDraft.value;
                replacement.focus({ preventScroll: true });
                replacement.setSelectionRange(noteDraft.start, noteDraft.end);
              }
            }

            // The delivery indicator uses this same confirmed cart, without an extra read.
            patchDrawerDeliveryBar(cart);
            if (window.DGCart) window.DGCart.restoreStatus();

            if (typeof window.DG_applyZapietSlotMenuTextColors === 'function') {
              [100, 400, 1000].forEach(function (ms) {
                setTimeout(window.DG_applyZapietSlotMenuTextColors, ms);
              });
            }
            dgSyncFormLightScheme();

            // Restaurer le scroll après le re-render (requestAnimationFrame pour attendre le paint)
            requestAnimationFrame(function () {
              const newItemsList = document.getElementById('dg-cart-items-list');
              if (newItemsList && savedScroll > 0) newItemsList.scrollTop = savedScroll;
            });

            // Re-apply open state if needed
            if (wasOpen) {
              const newDrawer = document.getElementById('dg-cart-drawer');
              if (newDrawer) {
                newDrawer.classList.add('active');
                newDrawer.setAttribute('aria-hidden', 'false');
                document.body.style.overflow = 'hidden';
              }
            }
            return true;
          }
        }
        throw new Error('Section du panier absente.');
      })
      .finally(function () {
        clearTimeout(timeout);
        if (renderId === _drawerRenderId) target.removeAttribute('aria-busy');
      });
  }

  // ─── Patch drawer delivery bar with zone-aware threshold ───
  function patchDrawerDeliveryBar(confirmedCart) {
    var barEl = document.querySelector('#dg-cart-drawer .dg-shipping-bar');
    if (!barEl) return;

    // Read zone from localStorage (same key as header bar)
    var zone = null;
    var threshold = 10000;
    try {
      var raw = localStorage.getItem('dg_postal_zone');
      if (raw) {
        var data = JSON.parse(raw);
        var ZONES = {
          latuque: { threshold: 10000, label: '100$', name: 'La Tuque' },
          region:  { threshold: 25000, label: '250$', name: 'ta région' },
          wemontaci: { threshold: 25000, label: '250$', name: 'Wemotaci' }
        };
        if (data && data.zone && ZONES[data.zone]) {
          zone = { key: data.zone, config: ZONES[data.zone], postal: data.postal };
          threshold = zone.config.threshold;
        }
      }
    } catch (e) {}

    // Get current cart total from the page
    Promise.resolve(confirmedCart || _currentCart)
      .then(function (cart) {
        if (!cart) return;
        var totalPrice =
          typeof window.DG_fsProgressMerchandiseCents === 'function'
            ? window.DG_fsProgressMerchandiseCents(cart)
            : cart.total_price || 0;
        var remaining = threshold - totalPrice;
        var pct = Math.min(Math.round((totalPrice / threshold) * 100), 100);

        // Update fill
        var fillEl = document.getElementById('dg-drawer-progress-fill');
        if (fillEl) {
          fillEl.style.width = (zone ? pct : 0) + '%';
        }

        // Update text
        var textEl = document.getElementById('dg-drawer-delivery-text');
        if (textEl) {
          var truckSvg = '<svg class="dg-shipping-bar__icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/><path d="M3 9h4"/></svg>';
          var checkSvg = '<svg class="dg-shipping-bar__icon dg-shipping-bar__icon--success" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l5 5l10 -10"/></svg>';

          if (!zone) {
            textEl.innerHTML = truckSvg + '<span>Entre ton <a href="#" onclick="if(typeof dgFsOpenPostalInput===\'function\'){dgFsOpenPostalInput();window.scrollTo({top:0,behavior:\'smooth\'});}closeCartDrawer();return false;" style="color:#4DA3FF;text-decoration:underline;cursor:pointer;font-weight:600;">code postal</a> pour voir ta livraison gratuite</span>';
          } else if (remaining > 0) {
            textEl.innerHTML = truckSvg + '<span>Encore&nbsp;<strong>' + formatDrawerMoney(remaining) + '</strong>&nbsp;pour la livraison gratuite</span>';
          } else {
            textEl.innerHTML = checkSvg + '<span><strong>Livraison gratuite</strong>&nbsp;débloquée&nbsp;!</span>';
          }
        }

        // Toggle complete class
        if (remaining <= 0 && zone) {
          barEl.classList.add('dg-shipping-bar--complete');
        } else {
          barEl.classList.remove('dg-shipping-bar--complete');
        }
      })
      .catch(function () {});
  }

  function formatDrawerMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }


  // â”€â”€â”€ Drawer qty: CAPTURE PHASE â€” intercepte +/- avant le onclick Liquid â”€â”€â”€
  // changeCartItemQty — called by inline onclick on +/- and trash buttons
  window.changeCartItemQty = function (key, qty) {
    var itemEl = document.querySelector('.dg-cart-item[data-key="' + key + '"]');

    window._dgCartPending = true;
    if (itemEl) { itemEl.style.opacity = '0.65'; itemEl.style.pointerEvents = 'none'; }

    clearTimeout(_drawerTimers[key]);
    _drawerTimers[key] = setTimeout(function () {
      delete _drawerTimers[key];
      if (Object.keys(_drawerTimers).length === 0) window._dgCartPending = false;
      _doDrawerChange(key, Math.max(0, qty), itemEl);
    }, 300);
  };

  var _drawerTimers = {};  // key → debounce timer

  function _doDrawerChange(key, finalQty, itemEl) {
    window._dgCartPending = true;
    if (itemEl) itemEl.style.opacity = '0.5';

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: finalQty })
    })
      .then(function (res) { if (!res.ok) throw new Error('Modification du panier refusée.'); return res.json(); })
      .then(function () {
        refreshCartState();
        window._dgCartPending = false;
      })
      .catch(function (err) {
        window._dgCartPending = false;
        if (itemEl) itemEl.style.opacity = '1';
        console.error('[DG Cart] change failed:', err);
      });
  };

  // =========================================
  // Header Cart Badge
  // =========================================
  // Source de vérité unique du montant header (#dg-cart-amount).
  // Le prix NET wholesale n'est PAS fiable côté thème (le snippet wcp_cart
  // legacy n'est pas rendu) : c'est l'app WPD qui injecte le net dans les
  // éléments [data-wpd-cart-total], dont le sous-total du tiroir #dg-drawer-total.
  // → On MIROITE ce sous-total : le header affiche exactement ce que le client
  // voit dans le tiroir. Anti-clignotement : dédup + "sticky remise".
  var _hdrAmtText = null;        // dernier texte réellement écrit
  var _hdrShownDiscount = false; // un total net wholesale a déjà été affiché

  // "10,50 $" / "1 234,56 $" / "$10.50" → centimes. Tolère virgule ou point décimal.
  function dgParseMoneyToCents(str) {
    var s = (str || '').replace(/[^\d.,]/g, '');
    if (!s) return null;
    var decPos = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    var intPart, decPart;
    if (decPos === -1) { intPart = s; decPart = '00'; }
    else { intPart = s.slice(0, decPos); decPart = (s.slice(decPos + 1) + '00').slice(0, 2); }
    intPart = intPart.replace(/[.,]/g, '');
    var cents = (parseInt(intPart || '0', 10) * 100) + parseInt(decPart || '0', 10);
    return isNaN(cents) ? null : cents;
  }

  // Lit le sous-total du tiroir. L'app WPD le transforme en « <s>original</s> net » :
  // on prend la PLUS PETITE valeur (= net). { cents, multiple } ; multiple=true
  // signifie qu'une remise est affichée (2+ montants).
  function dgReadDrawerNetCents() {
    var el = document.getElementById('dg-drawer-total');
    if (!el) return null;
    var txt = el.textContent || '';
    if (txt.indexOf('$') === -1) return null;
    var vals = [];
    txt.split('$').forEach(function (p) {
      var c = dgParseMoneyToCents(p);
      if (c != null && c > 0) vals.push(c);
    });
    if (!vals.length) return null;
    return { cents: Math.min.apply(null, vals), multiple: vals.length > 1 };
  }

  // Renvoie { text, fromDiscount } pour le montant header.
  function computeHeaderCartAmount(cart) {
    if (!cart || cart.item_count < 1) return { text: '', fromDiscount: false };
    // 1. Net réellement affiché dans le tiroir (app WPD) — fiable sur toute page.
    var drawer = dgReadDrawerNetCents();
    if (drawer && drawer.multiple) {
      return { text: '  ' + window.DG.utils.formatMoney(drawer.cents, '{{amount_with_comma_separator}} $'), fromDiscount: true };
    }
    // 2. Hash WCP legacy (filet de sécurité s'il existe).
    var hash = window.wcp_data && window.wcp_data.discounted_hash;
    if (hash && hash.formatted_wcp_total) {
      return { text: '  ' + window.DG.utils.decodeHtmlEntities(hash.formatted_wcp_total), fromDiscount: true };
    }
    // 3. Prix catalogue (retail, ou wholesale avant calcul WPD).
    if (cart.total_price > 0) {
      return { text: '  ' + window.DG.utils.formatMoney(cart.total_price, '{{amount_with_comma_separator}} $'), fromDiscount: false };
    }
    return { text: '', fromDiscount: false };
  }

  // Écriture pure (idempotente + anti-régression remise). Renvoie le res utilisé.
  function writeHeaderCartAmount(cart) {
    var amountEl = document.getElementById('dg-cart-amount');
    if (!amountEl) return null;
    var res = computeHeaderCartAmount(cart);

    // Panier vide → reset état + masque (déduppé).
    if (!cart || cart.item_count < 1) {
      _hdrShownDiscount = false;
      if (_hdrAmtText !== '') {
        _hdrAmtText = '';
        amountEl.textContent = '';
        amountEl.style.display = 'none';
      }
      return res;
    }

    // Sticky remise : ne pas retomber sur le catalogue tant qu'un net a été montré
    // (l'app WPD peut momentanément ré-afficher le catalogue pendant un recalcul).
    if (!res.fromDiscount && _hdrShownDiscount) return res;

    // Dédup : pas de réécriture inutile (tue le repaint / clignotement).
    if (res.text === _hdrAmtText) return res;

    _hdrAmtText = res.text;
    if (res.fromDiscount) _hdrShownDiscount = true;
    amountEl.textContent = res.text;
    amountEl.style.display = res.text ? '' : 'none';
    return res;
  }

  // Le net est injecté par l'app WPD de façon ASYNCHRONE (après ajout ET au
  // chargement). On ré-évalue ~5 s par panier (signature = count:total_price),
  // une seule fois par panier. Déduppé + sticky → polling INVISIBLE qui ne fait
  // que converger vers le net affiché dans le tiroir, sans jamais clignoter.
  var _hdrSettleTimer = null;
  var _hdrSettleSig = null;
  function ensureHeaderSettle(cart) {
    if (!cart || cart.item_count < 1) {
      if (_hdrSettleTimer) clearInterval(_hdrSettleTimer);
      _hdrSettleTimer = null;
      _hdrSettleSig = null;
      return;
    }
    var sig = cart.item_count + ':' + cart.total_price;
    if (sig === _hdrSettleSig) return;
    _hdrSettleSig = sig;
    if (_hdrSettleTimer) { clearInterval(_hdrSettleTimer); _hdrSettleTimer = null; }
    var n = 0;
    _hdrSettleTimer = setInterval(function () {
      if (sig !== _hdrSettleSig) return;
      writeHeaderCartAmount(cart);
      if (++n >= 16) { clearInterval(_hdrSettleTimer); _hdrSettleTimer = null; }
    }, 300);
  }

  // Writer public : écrit + lance la convergence (couvre chargement + events).
  function setHeaderCartAmount(cart) {
    // Panier différent (ajout/retrait/qty) → on ré-évalue la remise à zéro
    // pour ne pas conserver un net périmé d'un panier précédent.
    if (cart && cart.item_count >= 1) {
      var sig = cart.item_count + ':' + cart.total_price;
      if (sig !== _hdrSettleSig) _hdrShownDiscount = false;
    }
    writeHeaderCartAmount(cart);
    ensureHeaderSettle(cart);
  }
  window.dgSetHeaderCartAmount = setHeaderCartAmount;

  function updateHeaderBadge(cart) {
    var badges = [
      document.getElementById('dg-header-cart-badge'),
      document.getElementById('dg-bottom-cart-badge')
    ];
    badges.forEach(function (badge) {
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });

    setHeaderCartAmount(cart);
  }

  function scheduleHeaderBadgeRefresh(cart) {
    updateHeaderBadge(cart);
  }

  // =========================================
  // Cart Note (Debounced Save)
  // =========================================
  let noteTimeout = null;
  let noteRevision = 0;
  let saveNote = null;
  document.addEventListener('input', function (e) {
    if (e.target && (e.target.id === 'dg-cart-note' || e.target.id === 'dg-page-cart-note')) {
      clearTimeout(noteTimeout);
      var revision = ++noteRevision;
      var value = e.target.value;
      if (window.DGCart) window.DGCart.setNotePending(true);
      saveNote = function () {
        saveNote = null;
        clearTimeout(noteTimeout);
        // A note-only update does not alter Zapiet attributes; the shared queue orders it.
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({ note: value })
        }).then(function (response) {
          if (!response.ok) throw new Error('La note n’a pas pu être enregistrée. Vérifiez votre panier.');
        }).catch(function (error) {
          if (window.DGCart) window.DGCart.showError(error.message);
        }).finally(function () {
          if (revision === noteRevision && window.DGCart) {
            window.DGCart.setNotePending(false);
            window.DGCart.clearPendingMessage();
          }
        });
      };
      noteTimeout = setTimeout(saveNote, 800);
    }
  });
  document.addEventListener('blur', function (e) {
    if (saveNote && e.target && (e.target.id === 'dg-cart-note' || e.target.id === 'dg-page-cart-note')) saveNote();
  }, true);



  // Mise Ã  jour du badge Ã  chaque changement du cart
  document.addEventListener('dg:cart:updated', function (e) {
    if (!e.detail || e.detail.source !== 'dg-cart-state') {
      window.refreshCartState();
      return;
    }
    var cart = e.detail && e.detail.cart;
    if (cart) scheduleHeaderBadgeRefresh(cart);
    // Synce toutes les fiches produits (QV ou tiroir peuvent avoir changé le panier)
    updateAllProductCards();
  });

})();

/* ===================================================================
   DG PRODUCT CARD -- Inline Counter (Add -> Show +-)
   =================================================================== */
(function () {

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* -- Helpers -- */
  function getVariantId(form) {
    var inp = form.querySelector('input[name="id"]');
    return inp ? inp.value : null;
  }

  function getQty(form) {
    return parseInt(form.dataset.qty || '0');
  }

  function showCounter(form, qty) {
    var addBtn = form.querySelector('.dg-product-card__add-btn-inline');
    var counter = form.querySelector('.dg-product-card__counter');
    var valEl = form.querySelector('.dg-counter-val');
    if (addBtn) addBtn.style.display = 'none';
    if (counter) counter.style.display = 'flex';
    if (valEl) valEl.value = qty;
    form.dataset.qty = qty;
    var card = form.closest('.dg-product-card');
    if (card) card.classList.add('is-selected');
  }

  function showAddBtn(form) {
    var addBtn = form.querySelector('.dg-product-card__add-btn-inline');
    var counter = form.querySelector('.dg-product-card__counter');
    if (counter) counter.style.display = 'none';
    if (addBtn) addBtn.style.display = 'flex';
    form.dataset.qty = 0;
    var card = form.closest('.dg-product-card');
    if (card) card.classList.remove('is-selected');
    updateBackorderWarning(form);
  }

  /* -- Backorder warning -- */
  function updateBackorderWarning(form) {
    var row = form.closest('.dg-product-card__counter-row');
    var msgEl = row ? row.querySelector('.dg-product-card__backorder-msg') : null;
    // Fallback: search in wider parent containers (QV, cart drawer, cart page, product card)
    if (!msgEl) {
      var parent = form.closest('.dg-qv-bottom, .dg-cart-item, .dg-cart-line, .dg-product-card');
      msgEl = parent ? parent.querySelector('.dg-product-card__backorder-msg') : null;
    }
    if (!msgEl) return;

    var inv = parseInt(form.dataset.inventoryQty, 10);
    var qty = parseInt(form.dataset.qty || '0', 10);
    var stockAvail = isNaN(inv) ? NaN : Math.max(inv, 0);

    if (!isNaN(stockAvail) && qty > 0 && qty > stockAvail) {
      var backorder = qty - stockAvail;
      msgEl.textContent = '\u26A0 ' + backorder + ' en commande';
      msgEl.classList.add('is-visible');
    } else {
      msgEl.classList.remove('is-visible');
    }
  }

  // Expose to global scope for syncCardState & selectCardVariantFromSelect
  window.updateBackorderWarning = updateBackorderWarning;

  /* -- Fly to Cart Animation (Gamification) -- */
  function flyToCart(imgElement) {
    if (!imgElement) return;
    
    // Find cart icon (desktop or mobile) - targets the cart button in header
    var cartIcon = document.getElementById('dg-topbar-cart-btn') || document.querySelector('.dg-hdr__cart-btn');
    if (!cartIcon) {
      console.warn("FlyToCart: Cart icon not found");
      return;
    }

    var start = imgElement.getBoundingClientRect();
    var end = cartIcon.getBoundingClientRect();

    var clone = imgElement.cloneNode(false);
    clone.style.position = 'fixed';
    clone.style.top = start.top + 'px';
    clone.style.left = start.left + 'px';
    clone.style.width = start.width + 'px';
    clone.style.height = start.height + 'px';
    clone.style.zIndex = '99999';
    clone.style.transition = 'all 1.0s cubic-bezier(0.34, 1.2, 0.64, 1)'; // Bouncy trajectory, slower pace
    clone.style.borderRadius = '16px';
    clone.style.pointerEvents = 'none';
    clone.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
    clone.style.objectFit = 'cover';
    
    document.body.appendChild(clone);

    // Trigger reflow
    void clone.offsetWidth;

    // Fly! (Scale down and move to cart)
    clone.style.top = (end.top + end.height / 2 - 15) + 'px';
    clone.style.left = (end.left + end.width / 2 - 15) + 'px';
    clone.style.width = '30px';
    clone.style.height = '30px';
    clone.style.opacity = '0';
    clone.style.transform = 'scale(0.5) rotate(15deg)'; // Fun spin
    
    // Cleanup & Cart Bump
    setTimeout(function() {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      
      // Bump cart icon for satisfying feedback
      if(cartIcon) {
          cartIcon.style.transition = 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)';
          cartIcon.style.transform = 'scale(1.25)';
          setTimeout(function() { cartIcon.style.transform = 'scale(1)'; }, 200);
      }
    }, 1000); // Must match transition time
  }

  /* -- Cart AJAX -- */
  function cartAdd(variantId, qty, form) {
    if (form.dataset.cartAdding === 'true') return;
    form.dataset.cartAdding = 'true';
    updateBackorderWarning(form);
    
    var card = form.closest('.dg-product-card');
    var addBtn = form.querySelector('.dg-product-card__add-btn-inline');
    var img = card ? card.querySelector('.dg-product-card__img') : null;
    
    var origHTML = addBtn ? addBtn.innerHTML : '';
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.textContent = 'Ajout en cours…';
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('Ajout au panier refusé.'); return r.json(); })
      .then(function () {
        if (img) flyToCart(img);
        if (typeof window.refreshCartState === 'function') return window.refreshCartState();
      })
      .catch(function (err) {
        console.error('[DG] cart/add error:', err);
        if (typeof window.refreshCartState === 'function') return window.refreshCartState();
      }).finally(function () {
        delete form.dataset.cartAdding;
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-busy');
          addBtn.innerHTML = origHTML;
        }
      });
  }

  var _cardTimers = {};   // variantId → debounce timer

  function cartChange(variantId, qty, form) {
    if (qty > 0) { showCounter(form, qty); } else { showAddBtn(form); }
    updateBackorderWarning(form);

    // Disable individual buttons (not whole counter) to prevent click-through to card link
    var btnPlus = form.querySelector('.dg-counter-btn--plus');
    var btnMinus = form.querySelector('.dg-counter-btn--minus');
    function lockBtns(locked) {
      if (btnPlus) { btnPlus.disabled = locked; btnPlus.style.opacity = locked ? '0.45' : ''; }
      if (btnMinus) { btnMinus.disabled = locked; btnMinus.style.opacity = locked ? '0.45' : ''; }
    }
    lockBtns(true);

    window._dgCartPending = true;
    clearTimeout(_cardTimers[variantId]);
    _cardTimers[variantId] = setTimeout(function () {
      delete _cardTimers[variantId];
      // Keep _dgCartPending=true until API responds to block cart-sync polling

      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.toString(), quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('Modification du panier refusée.'); return r.json(); })
        .then(function (cart) {
          lockBtns(false);
          if (Object.keys(_cardTimers).length === 0) window._dgCartPending = false;
          // Use response directly — update only THIS card (avoids adjacent card flash)
          if (cart && cart.items) {
            window.DG_cartItems = cart.items;
            if (typeof window.syncCardState === 'function') window.syncCardState(form);
            if (typeof window.updateHeaderBadge === 'function') window.updateHeaderBadge(cart);
            // Refresh the cart drawer so it stays in sync without requiring a page reload
            if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
            document.dispatchEvent(new CustomEvent('dg:cart:updated', { detail: { cart: cart } }));
          }
        })
        .catch(function (err) {
          lockBtns(false);
          if (Object.keys(_cardTimers).length === 0) window._dgCartPending = false;
          console.error('[DG] cart/change error:', err);
          // Resync with real cart state (e.g. Shopify rejected qty > inventory)
          if (typeof window.refreshCartState === 'function') window.refreshCartState();
        });
    }, 300);
  }

  /* -- Click delegation -- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // "Ajouter" button
    var addBtn = t.closest('.dg-product-card__add-btn-inline');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (window.dgConsigne && window.dgConsigne.isSyncing()) return;
      var form = addBtn.closest('form[data-type="ajax-counter"]');
      if (!form) return;
      cartAdd(getVariantId(form), 1, form);
      return;
    }

    // Counter +
    var plus = t.closest('.dg-counter-btn--plus');
    if (plus) {
      if (window.dgConsigne && window.dgConsigne.isSyncing()) return;
      var form = plus.closest('form[data-type="ajax-counter"]');
      if (!form) return;
      cartChange(getVariantId(form), getQty(form) + 1, form);
      return;
    }

    // Counter -
    var minus = t.closest('.dg-counter-btn--minus');
    if (minus) {
      if (window.dgConsigne && window.dgConsigne.isSyncing()) return;
      var form = minus.closest('form[data-type="ajax-counter"]');
      if (!form) return;
      var newQ = getQty(form) - 1;
      cartChange(getVariantId(form), Math.max(0, newQ), form);
      return;
    }
  });

  // Manual qty input — shared logic for both change and Enter
  function applyManualQty(input) {
    var form = input.closest('form[data-type="ajax-counter"]');
    if (!form) return;
    var newQ = Math.max(0, parseInt(input.value) || 0);
    input.value = newQ; // enforce clean displayed value
    var currentQ = getQty(form);

    if (newQ === 0) {
      // Remove from cart
      cartChange(getVariantId(form), 0, form);
    } else if (currentQ === 0) {
      // Item not in cart yet — add it (qty = final quantity, not a delta)
      cartAdd(getVariantId(form), newQ, form);
    } else {
      // Item already in cart (increasing OR decreasing) → cartChange with final qty
      // Always use cartChange to avoid delta confusion and race conditions
      cartChange(getVariantId(form), newQ, form);
    }
  }

  // Manual qty input (tab away or blur)
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('dg-counter-val')) return;
    applyManualQty(e.target);
  });

  // Enter key on qty input — prevent form submit, trigger sync instead
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.classList.contains('dg-counter-val')) return;
    e.preventDefault();
    e.stopPropagation();
    e.target.blur(); // dismiss mobile keyboard
    applyManualQty(e.target);
  });

  // Init on load
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.DG_cartItems) return;
    document.querySelectorAll('form[data-type="ajax-counter"]').forEach(function (f) {
      var vid = parseInt(f.querySelector('input[name="id"]').value);
      var item = window.DG_cartItems.find(function (i) { return i.id === vid; });
      if (item && item.quantity > 0) showCounter(f, item.quantity);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dgSyncFormLightScheme);
  } else {
    dgSyncFormLightScheme();
  }

})();

/* ===================================================================
   PULSE FEEDBACK -- visual click ripple on counter buttons
   =================================================================== */
(function () {
  function pulse(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, 350);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    // Bouton + (counter)
    if (t.closest('.dg-counter-btn--plus')) {
      pulse(t.closest('.dg-counter-btn--plus'), 'dg--pulse-add');
      return;
    }

    // Bouton - (counter)
    if (t.closest('.dg-counter-btn--minus')) {
      pulse(t.closest('.dg-counter-btn--minus'), 'dg--pulse-remove');
      return;
    }

    // Bouton Ajouter (initial add)
    if (t.closest('.dg-product-card__add-btn-inline')) {
      pulse(t.closest('.dg-product-card__add-btn-inline'), 'dg--pulse-add');
      return;
    }
  }, { passive: true });

})();



/* ===================================================================
   DG CART DRAWER -- Swipe-to-Delete (Mobile)
   Swipe left on a cart item to reveal the red delete button.
   =================================================================== */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 40;

  var startX = 0;
  var startY = 0;
  var activeContainer = null;
  var isDragging = false;
  var isScrolling = null;

  function getContainer(el) {
    return el ? el.closest('.dg-cart-item__swipe-container') : null;
  }

  function closeAll(except) {
    document.querySelectorAll('.dg-cart-item__swipe-container.is-swiped').forEach(function (c) {
      if (c !== except) c.classList.remove('is-swiped');
    });
  }

  document.addEventListener('touchstart', function (e) {
    // Close other open items when touching anywhere
    var container = getContainer(e.target);
    closeAll(container);

    if (!container) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    activeContainer = container;
    isDragging = false;
    isScrolling = null;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!activeContainer) return;
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;

    if (isScrolling === null) {
      if (Math.abs(dy) > 6) { isScrolling = true; activeContainer = null; return; }
      if (Math.abs(dx) > 6) { isScrolling = false; }
      return;
    }

    if (isScrolling) { activeContainer = null; return; }

    if (dx < 0) {
      isDragging = true;
      e.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!activeContainer || !isDragging) { activeContainer = null; return; }

    var endX = e.changedTouches[0].clientX;
    var deltaX = endX - startX;

    if (deltaX < -SWIPE_THRESHOLD) {
      activeContainer.classList.add('is-swiped');
    } else {
      activeContainer.classList.remove('is-swiped');
    }

    activeContainer = null;
    isDragging = false;
    isScrolling = null;
  }, { passive: true });

})();
